import Button from "shared/components/Button";

const ActionButtons = ({
  onBack,
  onSubmit,
  loading,
  disabled = { next: false, previous: false },
  icons = {
    next: null,
    previous: null,
  },
  translation,
}) => {
  return (
    <div className="lf-select-products__actions">
      {onBack && (
        <Button onClick={onBack} type="secondary--link">
          {icons.previous}
          {translation.PREVIOUS}
        </Button>
      )}
      <Button
        type="primary"
        onClick={onSubmit}
        loading={loading}
        disabled={disabled.next}
      >
        {icons.next}
        {translation.NEXT}
      </Button>
    </div>
  );
};

export default ActionButtons;
